webpackJsonp([1],{

/***/ "0Tse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"action":"#"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h1',[_vm._v("Discrimination/Sexual Misconduct Complaint Form")]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger hidden",attrs:{"id":"message"}},[_c('h3',[_vm._v("Could not submit complaint!")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error.name},[_vm._v(_vm._s(error.name))])}))]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('div',{staticStyle:{"font-weight":"bold","padding-bottom":"10px"}},[_vm._v("Anonymous?")]),_vm._v(" "),_c('label',{staticClass:"radio-inline",attrs:{"for":"anonymousYES"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.anonymous),expression:"complaint.anonymous"}],attrs:{"type":"radio","name":"anonymous","id":"anonymousYES","value":"true"},domProps:{"checked":_vm._q(_vm.complaint.anonymous,"true")},on:{"change":function($event){_vm.$set(_vm.complaint, "anonymous", "true")}}}),_vm._v("\n              YES\n            ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline",attrs:{"for":"anonymousNO"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.anonymous),expression:"complaint.anonymous"}],attrs:{"type":"radio","name":"anonymous","id":"anonymousNO","value":"false"},domProps:{"checked":_vm._q(_vm.complaint.anonymous,"false")},on:{"change":function($event){_vm.$set(_vm.complaint, "anonymous", "false")}}}),_vm._v("\n              NO\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row",class:{'slide-down': !_vm.isAnonymous, 'slide-up': _vm.isAnonymous}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"name-div"}},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.name),expression:"complaint.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","id":"name"},domProps:{"value":(_vm.complaint.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"campusId-div"}},[_c('label',{attrs:{"for":"campusId"}},[_vm._v("Campus ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.campusId),expression:"complaint.campusId"}],staticClass:"form-control",attrs:{"type":"text","name":"campusId","id":"campusId"},domProps:{"value":(_vm.complaint.campusId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "campusId", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"department-div"}},[_c('label',{attrs:{"for":"department"}},[_vm._v("Department")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.department),expression:"complaint.department"}],staticClass:"form-control",attrs:{"type":"text","name":"department","id":"department"},domProps:{"value":(_vm.complaint.department)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "department", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"email-div"}},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.email),expression:"complaint.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","id":"email"},domProps:{"value":(_vm.complaint.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group",attrs:{"id":"address-div"}},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.address),expression:"complaint.address"}],staticClass:"form-control",attrs:{"name":"address","id":"address"},domProps:{"value":(_vm.complaint.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"phoneDay-div"}},[_c('label',{attrs:{"for":"phoneDay"}},[_vm._v("Phone (Daytime)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.phoneDay),expression:"complaint.phoneDay"}],staticClass:"form-control",attrs:{"type":"text","name":"phoneDay","id":"phoneDay"},domProps:{"value":(_vm.complaint.phoneDay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "phoneDay", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"phoneEvening-div"}},[_c('label',{attrs:{"for":"phoneEvening"}},[_vm._v("Phone (Evening)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.phoneEvening),expression:"complaint.phoneEvening"}],staticClass:"form-control",attrs:{"type":"text","name":"phoneEvening","id":"phoneEvening"},domProps:{"value":(_vm.complaint.phoneEvening)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "phoneEvening", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"status-div"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.status),expression:"complaint.status"}],attrs:{"type":"checkbox","name":"status","id":"statusF","value":"FACULTY_STAFF"},domProps:{"checked":Array.isArray(_vm.complaint.status)?_vm._i(_vm.complaint.status,"FACULTY_STAFF")>-1:(_vm.complaint.status)},on:{"change":function($event){var $$a=_vm.complaint.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="FACULTY_STAFF",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "status", $$c)}}}}),_vm._v("\n                Faculty / Staff\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.status),expression:"complaint.status"}],attrs:{"type":"checkbox","name":"status","id":"statusS","value":"STUDENT"},domProps:{"checked":Array.isArray(_vm.complaint.status)?_vm._i(_vm.complaint.status,"STUDENT")>-1:(_vm.complaint.status)},on:{"change":function($event){var $$a=_vm.complaint.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="STUDENT",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "status", $$c)}}}}),_vm._v("\n                Student\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.status),expression:"complaint.status"}],attrs:{"type":"checkbox","name":"status","id":"statusO","value":"OTHER"},domProps:{"checked":Array.isArray(_vm.complaint.status)?_vm._i(_vm.complaint.status,"OTHER")>-1:(_vm.complaint.status)},on:{"change":function($event){var $$a=_vm.complaint.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="OTHER",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "status", $$c)}}}}),_vm._v("\n                Other (Please specify)\n              ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOther),expression:"isOther"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.otherStatus),expression:"complaint.otherStatus"}],staticClass:"form-control",attrs:{"type":"text","name":"otherStatus","id":"otherStatus"},domProps:{"value":(_vm.complaint.otherStatus)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "otherStatus", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#f0f0f0","margin-bottom":"20px"}},[_c('div',{staticClass:"container"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"accusedName-div"}},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.name),expression:"complaint.accused.name"}],staticClass:"form-control",attrs:{"type":"text","name":"accusedName","id":"accusedName"},domProps:{"value":(_vm.complaint.accused.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint.accused, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"accusedTitle-div"}},[_c('label',{attrs:{"for":"accusedTitle"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.title),expression:"complaint.accused.title"}],staticClass:"form-control",attrs:{"type":"text","name":"accusedTitle","id":"accusedTitle"},domProps:{"value":(_vm.complaint.accused.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint.accused, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"accusedDepartment-div"}},[_c('label',{attrs:{"for":"accusedDepartment"}},[_vm._v("Department")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.department),expression:"complaint.accused.department"}],staticClass:"form-control",attrs:{"type":"text","name":"accusedDepartment","id":"accusedDepartment"},domProps:{"value":(_vm.complaint.accused.department)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint.accused, "department", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"accusedEmail-div"}},[_c('label',{attrs:{"for":"accusedEmail"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.email),expression:"complaint.accused.email"}],staticClass:"form-control",attrs:{"type":"accusedEmail","name":"accusedEmail","id":"accusedEmail"},domProps:{"value":(_vm.complaint.accused.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint.accused, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group",attrs:{"id":"accussedAddress-div"}},[_c('label',{attrs:{"for":"accussedAddress"}},[_vm._v("Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.address),expression:"complaint.accused.address"}],staticClass:"form-control",attrs:{"name":"accussedAddress","id":"accussedAddress"},domProps:{"value":(_vm.complaint.accused.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint.accused, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"accusedPhone-div"}},[_c('label',{attrs:{"for":"accusedPhone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.phone),expression:"complaint.accused.phone"}],staticClass:"form-control",attrs:{"type":"text","name":"accusedPhone","id":"accusedPhone"},domProps:{"value":(_vm.complaint.accused.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint.accused, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group",attrs:{"id":"accusedStatus-div"}},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.status),expression:"complaint.accused.status"}],attrs:{"type":"checkbox","name":"accusedStatus","id":"accusedStatusF","value":"FACULTY_STAFF"},domProps:{"checked":Array.isArray(_vm.complaint.accused.status)?_vm._i(_vm.complaint.accused.status,"FACULTY_STAFF")>-1:(_vm.complaint.accused.status)},on:{"change":function($event){var $$a=_vm.complaint.accused.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="FACULTY_STAFF",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint.accused, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint.accused, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint.accused, "status", $$c)}}}}),_vm._v("\n                Faculty / Staff\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.status),expression:"complaint.accused.status"}],attrs:{"type":"checkbox","name":"accusedStatus","id":"accusedStatusS","value":"STUDENT"},domProps:{"checked":Array.isArray(_vm.complaint.accused.status)?_vm._i(_vm.complaint.accused.status,"STUDENT")>-1:(_vm.complaint.accused.status)},on:{"change":function($event){var $$a=_vm.complaint.accused.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="STUDENT",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint.accused, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint.accused, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint.accused, "status", $$c)}}}}),_vm._v("\n                Student\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.status),expression:"complaint.accused.status"}],attrs:{"type":"checkbox","name":"accusedStatus","id":"accusedStatusO","value":"OTHER"},domProps:{"checked":Array.isArray(_vm.complaint.accused.status)?_vm._i(_vm.complaint.accused.status,"OTHER")>-1:(_vm.complaint.accused.status)},on:{"change":function($event){var $$a=_vm.complaint.accused.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="OTHER",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint.accused, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint.accused, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint.accused, "status", $$c)}}}}),_vm._v("\n                Other (Please specify)\n              ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOtherAccused),expression:"isOtherAccused"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.accused.otherStatus),expression:"complaint.accused.otherStatus"}],staticClass:"form-control",attrs:{"type":"text","name":"otherAccusedStatus","id":"otherAccusedStatus"},domProps:{"value":(_vm.complaint.accused.otherStatus)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint.accused, "otherStatus", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 form-group",attrs:{"id":"description-div"}},[_vm._m(7),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.description),expression:"complaint.description"}],staticClass:"form-control",staticStyle:{"height":"200px"},attrs:{"name":"description","id":"description"},domProps:{"value":(_vm.complaint.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group",attrs:{"id":"basis-div"}},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"RACE_COLOR"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"RACE_COLOR")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="RACE_COLOR",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Race/Color\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"AGE"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"AGE")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="AGE",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Age\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"SEXUAL_MISCONDUCT"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"SEXUAL_MISCONDUCT")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="SEXUAL_MISCONDUCT",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Sexual Misconduct\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"HEIGHT"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"HEIGHT")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="HEIGHT",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Height\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"RETALIATION"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"RETALIATION")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="RETALIATION",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Retaliation\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"GENDER"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"GENDER")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="GENDER",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Gender\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"WEIGHT"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"WEIGHT")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="WEIGHT",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Weight\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"NATIONAL_ORIGIN_CREED_ANCESTRY"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"NATIONAL_ORIGIN_CREED_ANCESTRY")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="NATIONAL_ORIGIN_CREED_ANCESTRY",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                National Origin/Creed/Ancestry\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"RELIGION"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"RELIGION")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="RELIGION",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Religion\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"VETERAN_STATUS"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"VETERAN_STATUS")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="VETERAN_STATUS",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Veteran Status\n              ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.basis),expression:"complaint.basis"}],attrs:{"type":"checkbox","name":"basis","value":"DISABILITY"},domProps:{"checked":Array.isArray(_vm.complaint.basis)?_vm._i(_vm.complaint.basis,"DISABILITY")>-1:(_vm.complaint.basis)},on:{"change":function($event){var $$a=_vm.complaint.basis,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="DISABILITY",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.complaint, "basis", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.complaint, "basis", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.complaint, "basis", $$c)}}}}),_vm._v("\n                Disability\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 form-group",attrs:{"id":"witnesses-div"}},[_vm._m(9),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.hasWitnesses),expression:"complaint.hasWitnesses"}],attrs:{"type":"radio","name":"witnesses","value":"true"},domProps:{"checked":_vm._q(_vm.complaint.hasWitnesses,"true")},on:{"change":function($event){_vm.$set(_vm.complaint, "hasWitnesses", "true")}}}),_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.hasWitnesses),expression:"complaint.hasWitnesses"}],attrs:{"type":"radio","name":"witnesses","value":"false"},domProps:{"checked":_vm._q(_vm.complaint.hasWitnesses,"false")},on:{"change":function($event){_vm.$set(_vm.complaint, "hasWitnesses", "false")}}}),_vm._v("\n            No\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row",class:{'slide-down': _vm.hasWitnessesCheck, 'slide-up': !_vm.hasWitnessesCheck}},[_vm._l((_vm.complaint.witnesses),function(witness){return _c('div',{key:witness.position},[_c('div',{staticClass:"col-md-5 form-group"},[_c('label',{staticClass:"witness-name",attrs:{"for":'witnessName'+witness.position}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(witness.name),expression:"witness.name"}],staticClass:"form-control input-lg",attrs:{"type":"text","name":'witnessName'+witness.position,"id":'witnessName'+witness.position},domProps:{"value":(witness.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(witness, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5 form-group"},[_c('label',{attrs:{"for":'witnessContactInfo'+witness.position}},[_vm._v("Contact Information")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(witness.contactInfo),expression:"witness.contactInfo"}],staticClass:"form-control input-lg",attrs:{"type":"text","name":'witnessContactInfo'+witness.position,"id":'witnessContactInfo'+witness.position},domProps:{"value":(witness.contactInfo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(witness, "contactInfo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"padding-top":"29px"}},[_c('a',{staticClass:"btn btn-default btn-block btn-lg",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeWitness(witness.position)}}},[_c('span',{staticClass:"fa fa-trash-o"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"padding-top":"29px"}},[_c('a',{staticClass:"btn btn-default btn-block btn-lg",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.addWitness($event)}}},[_c('span',{staticClass:"fa fa-plus"})])])])}),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{attrs:{"for":"witnessesComments"}},[_vm._v("Comments")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.witnessesComments),expression:"complaint.witnessesComments"}],staticClass:"form-control",attrs:{"name":"witnessesComments","id":"witnessesComments"},domProps:{"value":(_vm.complaint.witnessesComments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "witnessesComments", $event.target.value)}}})])],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 form-group",attrs:{"id":"stopAction-div"}},[_vm._m(10),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.stopAction),expression:"complaint.stopAction"}],attrs:{"type":"radio","name":"stopAction","value":"true"},domProps:{"checked":_vm._q(_vm.complaint.stopAction,"true")},on:{"change":function($event){_vm.$set(_vm.complaint, "stopAction", "true")}}}),_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.stopAction),expression:"complaint.stopAction"}],attrs:{"type":"radio","name":"stopAction","value":"false"},domProps:{"checked":_vm._q(_vm.complaint.stopAction,"false")},on:{"change":function($event){_vm.$set(_vm.complaint, "stopAction", "false")}}}),_vm._v("\n            No\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row",class:{'slide-down': _vm.ifStopAction, 'slide-up': !_vm.ifStopAction}},[_c('div',{staticClass:"col-md-12 form-group",attrs:{"id":"stopActionDescription-div"}},[_c('label',{attrs:{"for":"stopActionTaken"}},[_vm._v("Please summarize the action taken:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.stopActionTaken),expression:"complaint.stopActionTaken"}],staticClass:"form-control",attrs:{"name":"stopActionTaken","id":"stopActionTaken"},domProps:{"value":(_vm.complaint.stopActionTaken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "stopActionTaken", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 form-group",attrs:{"id":"resolution-div"}},[_vm._m(11),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.complaint.resolution),expression:"complaint.resolution"}],staticClass:"form-control",attrs:{"name":"resolution","id":"resolution"},domProps:{"value":(_vm.complaint.resolution)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.complaint, "resolution", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('vue-recaptcha',{ref:"invisibleRecaptcha",attrs:{"sitekey":"6LfyzwQTAAAAAPRpD5oNsRs91TjdvhGkp_v8mfcH"},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}}),_vm._v(" "),_vm._m(12)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h2',[_vm._v("Person alleging discrimination/sexual misconduct or person referring the complaint:")]),_vm._v(" "),_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Name "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"email"}},[_vm._v("Email Address "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"status"}},[_vm._v("University Status "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h2',[_vm._v("Person who is accused of discrimination/sexual misconduct:")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"accusedName"}},[_vm._v("Name "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"accusedStatus"}},[_vm._v("University Status "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"description"}},[_vm._v("Describe specific act(s) alleged with name(s), date(s), time(s) and location(s) if possible "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12",attrs:{"id":"basis"}},[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("Basis of Discrimination/Sexual Misconduct "),_c('span',{staticClass:"required"},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-weight":"bold","padding-bottom":"10px"}},[_vm._v("Were witnesses present for the alleged behaviour? "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-weight":"bold","padding-bottom":"10px"}},[_vm._v("If alleging sexual misconduct, did you take any action to stop the sexual misconduct? "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"resolution"}},[_vm._v("How would you like to see the situation resolution? "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-lg",staticStyle:{"margin-top":"15px"},attrs:{"type":"submit","id":"submit-btn"}},[_c('span',{staticClass:"fa fa-envelope"}),_vm._v(" Submit")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var $ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */]
  },
  data: function data() {
    return {
      witnessPosition: 1,
      errors: [],
      complaint: {
        anonymous: false,
        name: '',
        campusId: '',
        department: '',
        email: '',
        address: '',
        phoneDay: '',
        phoneEvening: '',
        status: [],
        otherStatus: '',
        description: '',
        basis: [],
        hasWitnesses: '',
        witnesses: [{ position: '1', name: '', contactInfo: '' }],
        witnessesComments: '',
        stopAction: '',
        stopActionTaken: '',
        resolution: '',
        accused: {
          name: '',
          title: '',
          department: '',
          email: '',
          address: '',
          phone: '',
          status: [],
          otherStatus: ''
        },
        verification: ''
      }
    };
  },

  computed: {
    isAnonymous: function isAnonymous() {
      if (this.complaint.anonymous === 'true') {
        return true;
      }
      return false;
    },
    isOther: function isOther() {
      if (this.complaint.status.includes('OTHER')) {
        return true;
      }
      return false;
    },
    isOtherAccused: function isOtherAccused() {
      if (this.complaint.accused.status.includes('OTHER')) {
        return true;
      }
      return false;
    },
    hasWitnessesCheck: function hasWitnessesCheck() {
      if (this.complaint.hasWitnesses === 'true') {
        return true;
      }
      return false;
    },
    ifStopAction: function ifStopAction() {
      if (this.complaint.stopAction === 'true') {
        return true;
      }
      return false;
    }
  },
  methods: {
    addWitness: function addWitness() {
      var vue = this;
      vue.witnessPosition++;
      var witness = { position: vue.witnessPosition, name: '', contactInfo: '' };
      vue.complaint.witnesses.push(witness);
      setTimeout(function () {
        var witnessName = 'witnessName' + vue.witnessPosition;
        console.log('Looking for ' + witnessName);
        document.getElementById(witnessName).focus();
      }, 100);
    },
    removeWitness: function removeWitness(position) {
      for (var i = 0; i < this.complaint.witnesses.length; i++) {
        if (this.complaint.witnesses[i].position === position) {
          this.complaint.witnesses.splice(i, 1);
        }
      }
      if (this.complaint.witnesses.length === 0) {
        this.addWitness();
      }
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    submitForm: function submitForm() {
      console.log('Submitting form');
      var vue = this;
      vue.errors = [];
      var message = document.getElementById('message');
      message.classList.add('hidden');
      document.getElementById('name-div').classList.remove('has-error');
      document.getElementById('email-div').classList.remove('has-error');
      document.getElementById('status-div').classList.remove('has-error');
      document.getElementById('accusedName-div').classList.remove('has-error');
      document.getElementById('accusedStatus-div').classList.remove('has-error');
      document.getElementById('description-div').classList.remove('has-error');
      document.getElementById('basis-div').classList.remove('has-error');
      document.getElementById('witnesses-div').classList.remove('has-error');
      var witnessName = document.getElementsByClassName('witness-name');
      if (witnessName && witnessName[0]) {
        witnessName[0].classList.remove('has-error');
      }
      document.getElementById('stopAction-div').classList.remove('has-error');
      document.getElementById('stopActionDescription-div').classList.remove('has-error');
      document.getElementById('resolution-div').classList.remove('has-error');

      if (vue.complaint.anonymous !== 'true') {
        if (vue.complaint.name.trim() === '') {
          var error = { name: 'If you would like to be anonymous, please select that option otherwise you need to provide a name' };
          vue.errors.push(error);
          var nameDiv = document.getElementById('name-div');
          nameDiv.classList.add('has-error');
        }

        if (vue.complaint.email.trim() === '' || !vue.validateEmail(vue.complaint.email)) {
          var _error = { name: 'Please provide a valid email address' };
          vue.errors.push(_error);
          var emailDiv = document.getElementById('email-div');
          emailDiv.classList.add('has-error');
        }

        if (vue.complaint.status.length === 0) {
          var _error2 = { name: 'Please specify if you\'re a student, faculty or other' };
          vue.errors.push(_error2);
          var statusDiv = document.getElementById('status-div');
          statusDiv.classList.add('has-error');
        } else {
          if (vue.complaint.status.includes('OTHER') && vue.complaint.otherStatus.trim() === '') {
            var _error3 = { name: 'Please provide other university status' };
            vue.errors.push(_error3);
            var _statusDiv = document.getElementById('status-div');
            _statusDiv.classList.add('has-error');
          }
        }
      }

      if (vue.complaint.accused.name.trim() === '') {
        var _error4 = { name: 'Please specify name of accused person' };
        vue.errors.push(_error4);
        var accusedNameDiv = document.getElementById('accusedName-div');
        accusedNameDiv.classList.add('has-error');
      }

      if (vue.complaint.accused.status.length === 0) {
        var _error5 = { name: 'Please specify university status of accused person' };
        vue.errors.push(_error5);
        var accusedStatusDiv = document.getElementById('accusedStatus-div');
        accusedStatusDiv.classList.add('has-error');
      }

      if (vue.complaint.description.trim() === '') {
        var _error6 = { name: 'Please provide reason of complaint' };
        vue.errors.push(_error6);
        var descriptionDiv = document.getElementById('description-div');
        descriptionDiv.classList.add('has-error');
      }

      if (vue.complaint.basis.length === 0) {
        var _error7 = { name: 'Please provide basis of complaint' };
        vue.errors.push(_error7);
        var basisDiv = document.getElementById('basis-div');
        basisDiv.classList.add('has-error');
      }

      if (vue.complaint.hasWitnesses === '') {
        var _error8 = { name: 'Please tell us if there\'s witnesses' };
        vue.errors.push(_error8);
        var witnessesDiv = document.getElementById('witnesses-div');
        witnessesDiv.classList.add('has-error');
      } else if (vue.complaint.hasWitnesses === 'true') {
        if (vue.complaint.witnesses[0].name.trim() === '') {
          var _error9 = { name: 'Please provide name of witness' };
          vue.errors.push(_error9);
          var _witnessesDiv = document.getElementsByClassName('witness-name');
          _witnessesDiv[0].classList.add('has-error');
        }
      }

      if (vue.complaint.stopAction === '') {
        var _error10 = { name: 'Please tell us if you did anything to stop it' };
        vue.errors.push(_error10);
        var stopActionDiv = document.getElementById('stopAction-div');
        stopActionDiv.classList.add('has-error');
      } else if (vue.complaint.stopAction === 'true') {
        if (vue.complaint.stopActionTaken.trim() === '') {
          var _error11 = { name: 'Please tell us if what you did to stop it' };
          vue.errors.push(_error11);
          var _stopActionDiv = document.getElementById('stopActionDescription-div');
          _stopActionDiv.classList.add('has-error');
        }
      }

      if (vue.complaint.resolution.trim() === '') {
        var _error12 = { name: 'Please tell us how would you like to see the situation resolved' };
        vue.errors.push(_error12);
        var resolutionDiv = document.getElementById('resolution-div');
        resolutionDiv.classList.add('has-error');
      }

      if (vue.complaint.verification.trim() === '') {
        var _error13 = { name: 'Please verify that you\'re not a robot' };
        vue.errors.push(_error13);
      }

      if (vue.errors.length > 0) {
        message.classList.remove('hidden');
        window.scroll(0, 0);
      } else {
        $.post('/discrimination/api/v2/student-services/discrimination/complaints', this.complaint).done(function () {
          console.log('Done');
          vue.$router.push({ name: 'Sent' });
        }).fail(function (err) {
          console.error('Could not submit complaint: ', err);
          var error = { name: err.responseJSON };
          vue.errors.push(error);
          message.classList.remove('hidden');
          window.scroll(0, 0);
        });
      }

      document.getElementById('submit-btn').blur();
    },
    onVerify: function onVerify(response) {
      console.log('Verify: ' + response);
      this.complaint.verification = response;
    },
    onExpired: function onExpired() {
      console.log('Expired');
    },
    resetRecaptcha: function resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    }
  }
});

/***/ }),

/***/ "I3N+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-inverse navbar-fixed-top"},[_c('div',{staticClass:"header-alpha visible-md-block visible-lg-block"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('a',{attrs:{"href":"https://request-info.swau.edu/"}},[_vm._v("REQUEST INFO")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forms.swau.edu/visit"}},[_vm._v("VISIT")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/admissions"}},[_vm._v("APPLY")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/you-make-difference"}},[_vm._v("GIVE")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/alumni"}},[_vm._v("ALUMNI")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/search"}},[_c('span',{staticClass:"fa fa-search",staticStyle:{"margin-right":"5px"}}),_vm._v("SEARCH")])])])])]),_vm._v(" "),_c('div',{staticClass:"header-beta"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#swau-navbar-collapse","aria-expanded":"false"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"fa fa-bars",staticStyle:{"font-size":"26px"}})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":"https://www.swau.edu"}},[_c('img',{attrs:{"src":"https://app.swau.edu/images/logo.png"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"swau-navbar-collapse"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/about"}},[_vm._v("About")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/admissions-aid"}},[_vm._v("Admissions & Aid")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/academics"}},[_vm._v("Academics")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/campus-life"}},[_vm._v("Campus Life")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.swau.edu/events"}},[_vm._v("Events")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},[_c('div',{staticClass:"container"},[_c('a',{staticStyle:{"margin-right":"5px"},attrs:{"href":"https://www.swau.edu"}},[_c('span',{staticClass:"fa fa-home"})]),_vm._v("/ "),_c('a',{attrs:{"href":"/discrimination"}},[_vm._v("Discrimination / Sexual Misconduct Complaint Form")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"role":"contentinfo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 footer-left"},[_c('p',[_c('a',{attrs:{"href":"https://www.swau.edu"}},[_c('img',{attrs:{"src":"https://app.swau.edu/images/footer-logo.png","alt":"Southwestern Adventist University"}})])]),_vm._v(" "),_c('p',{staticStyle:{"padding-bottom":"30px"}},[_c('a',{attrs:{"href":"https://www.swau.edu/sitemap"}},[_vm._v("Site Map")]),_vm._v(" | "),_c('a',{attrs:{"href":"https://www.swau.edu/copyright"}},[_vm._v("Copyright")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 footer-center"},[_c('h2',[_vm._v("Address")]),_vm._v(" "),_c('p',{staticStyle:{"padding-bottom":"30px"}},[_c('a',{attrs:{"href":"https://www.google.com/maps/place/Southwestern+Adventist+University/@32.3963724,-97.3290354,17z/data=!3m1!4b1!4m2!3m1!1s0x864e446bbc5fbce9:0x9b338d9e54e8ef6c","target":"_blank"}},[_vm._v("100 W Hillcrest Street"),_c('br'),_vm._v("Keene, TX 76059")])]),_vm._v(" "),_c('h2',[_vm._v("Phone")]),_vm._v(" "),_c('p',{staticStyle:{"padding-bottom":"30px"}},[_c('a',{attrs:{"href":"tel:8004332240"}},[_vm._v("800.433.2240")]),_vm._v(" "),_c('br'),_c('a',{attrs:{"href":"tel:8176453921"}},[_vm._v("817.645.3921")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 footer-right"},[_c('h2',[_vm._v("Connect with us")]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"social-icons icon-circle icon-rotate list-unstyled list-inline"},[_c('li',[_c('a',{attrs:{"href":"http://www.facebook.com/southwestern.adventist.university","target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://twitter.com/southwesternau","target":"_blank"}},[_c('span',{staticClass:"fa fa-twitter"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.youtube.com/user/SouthwesternAU","target":"_blank"}},[_c('span',{staticClass:"fa fa-youtube"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vimeo.com/swau","target":"_blank"}},[_c('span',{staticClass:"fa fa-vimeo"})])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kn0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sent',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Kn9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sent_vue__ = __webpack_require__("Kn0P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6866000e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sent_vue__ = __webpack_require__("jlPT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6866000e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d81f838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("I3N+");
function injectStyle (ssrContext) {
  __webpack_require__("VRrF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d81f838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHHt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "VRrF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sent__ = __webpack_require__("Kn9b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NotFound__ = __webpack_require__("YcJa");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/discrimination',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/sent',
    name: 'Sent',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Sent__["a" /* default */]
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_4__components_NotFound__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4497964c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("qRul");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4497964c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jlPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"well",staticStyle:{"margin-top":"20px","text-align":"center","padding":"50px"}},[_c('h1',[_vm._v("Your complaint has been sent!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a4ab8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("0Tse");
function injectStyle (ssrContext) {
  __webpack_require__("MHHt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a4ab8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qRul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h1',[_vm._v("Page Not Found")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("gNGx");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// discrimination/js/app.b8db0679b11c5a9796be.js